import React from "react";
import { action, observable } from "mobx";
import { observer } from "mobx-react";

import { ApiUrls } from "@app/AppConstants";
import { applyDecorators } from "@app/Helpers/Decorator";
import { BannerModel } from "@app/Models/WebApiModels";
import ApiService from "@app/Services/ApiService";

import { BannerItem } from "./BannerItem/BannerItem";

@observer
export default class Banners extends React.Component<{}> {
    @observable private _banners: BannerModel[] = [];

    constructor(props: {}) {
        super(props);
        applyDecorators(this);
    }

    componentDidMount() {
        void this._loadData();
    }

    render() {
        return (
            <>
                {this._banners.map(x => {
                    return (
                        <BannerItem key={x.id} item={x} canHide />
                    );
                })}
            </>
        );
    }

    @action
    private async _loadData() {
        const { data } = await ApiService.getTypedData<BannerModel[]>(ApiUrls.MasterDataActualBannersUrl);
        this._banners = data;
    }
}